import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import es from 'vuetify/es5/locale/es'
Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'fa'
  },
  lang: {
    locales: { es: es },
    current: 'es'
  },
  theme: {
    themes: {
      light: {
        primary: process.env.VUE_APP_PRIMARY_COLOR,
        secondary: process.env.VUE_APP_SECONDARY_COLOR,
        table_header_title: process.env.VUE_APP_TABLE_HEADER_TITLE_COLOR,
        accent: '#8c9eff',
        error: '#b71c1c'
      }
    }
  }
})
